import { d as t, _ as c } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as o, createElementBlock as s, normalizeClass as l, normalizeStyle as n, createElementVNode as r } from "vue";
const a = t("setting"), i = /* @__PURE__ */ r("path", {
  d: "M512 1021.305c-24.253 0-51.2-5.39-75.453-18.863l-309.894-158.99c-53.895-26.947-86.232-83.536-86.232-142.82V323.368c0-61.979 32.337-115.873 86.232-142.82l309.894-158.99c45.81-24.253 102.4-24.253 148.21 0l309.896 158.99c53.894 26.947 86.231 83.536 86.231 142.82v377.264c0 61.979-32.337 115.873-86.231 142.82l-309.895 158.99c-21.558 13.474-48.505 18.863-72.758 18.863zm0-937.768c-13.474 0-24.253 2.695-37.726 8.084l-309.895 158.99c-26.947 13.473-43.116 43.115-43.116 72.757v377.264c0 29.642 16.169 56.59 43.116 72.757l309.895 158.99c24.252 10.779 51.2 10.779 75.452 0l309.895-158.99c26.947-13.473 43.116-40.42 43.116-72.757V323.368c0-29.642-16.169-56.59-43.116-72.757L549.726 91.62c-13.473-5.39-24.252-8.084-37.726-8.084zm0 644.042c-110.484 0-202.105-91.621-202.105-202.105S401.515 323.368 512 323.368s202.105 91.621 202.105 202.106S622.485 727.579 512 727.579zm0-323.368c-67.368 0-121.263 53.894-121.263 121.263S444.632 646.737 512 646.737s121.263-53.895 121.263-121.263S579.368 404.21 512 404.21z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = [
  i
];
function p(e, _, d, f, S, g) {
  return o(), s("svg", {
    class: l(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, m, 6);
}
const z = /* @__PURE__ */ c(a, [["render", p]]);
export {
  z as default
};
